import { deserialize } from 'cerialize'

export class ReceivingFileModel {
	@deserialize public id?: number
	@deserialize public file: string
	@deserialize public size: number
	@deserialize public name?: string
	@deserialize public created_at?: string
	@deserialize public updated_at?: string
}
